import api from './api';

import { GlobalStorage } from '../home-page/global-storage';
import { hasNoTranslationParam, NO_TRANSLATION_QUERY } from '@kano/i18n';

const client = {
  getLicensesBlock() {
    return this.getBlock('licenses');
  },
  async getCtaFull() {
    const params = {};
    const ctaFlow = await this.getCtaFlow();
    if (ctaFlow) {
      params.flow = ctaFlow;
    }
    return this.getBlock('cta-full', params);
  },
  async getCtaBlock() {
    const params = {};
    const ctaFlow = await this.getCtaFlow();
    if (ctaFlow) {
      params.flow = ctaFlow;
    }
    return this.getBlock('cta-block', params);
  },
  getQuickGuideBlock() {
    return this.getBlockFoSelectedRelation('quick-guide');
  },
  getFeaturesBlock() {
    return this.getBlockFoSelectedRelation('features');
  },
  getNewsBlock() {
    return this.getBlock('news');
  },
  getTrustpilotBlock() {
    return this.getBlock('trustpilot');
  },
  getBlockFoSelectedRelation(path) {
    return this.getBlock(path, {
      link: GlobalStorage.relationLink,
    });
  },
  getWalletSecurity() {
    return this.getBlock('wallet-security');
  },
  getAffiliateProgram() {
    return this.getBlock('affiliate-program');
  },
  getSolutionInNumbers() {
    return this.getBlock('solution-in-numbers');
  },
  getCryptoTrends() {
    return this.getBlockFoSelectedRelation('crypto-trends');
  },
  getWalletFunctionalityList() {
    return this.getBlock('wallet-functionality');
  },
  getWalletTrustpilot() {
    return this.getBlock('wallet-trustpilot');
  },
  getWalletFees() {
    return this.getBlock('wallet-fees');
  },
  getBlock(path, params = null) {
    const requestPath = `/lazy-block/${path}/`;
    const requestParams = { ...params };

    if (hasNoTranslationParam()) {
      requestParams[NO_TRANSLATION_QUERY] = true;
    }

    return api
      .get(requestPath, {
        params: requestParams,
      })
      .then(({ data }) => data);
  },
  getPublicOnrampTrustpilot() {
    return this.getBlock('public-onramp-trustpilot');
  },
  async getCtaFlow(){
    let flow = null;
    await GlobalStorage.isReady;
    if (GlobalStorage.isServiceFromCrypto) flow = 'sell-crypto';
    if (GlobalStorage.isServiceToCrypto) flow = 'buy-crypto';
    return flow;
  },
};

const blocks = {
  licenses: () => client.getLicensesBlock(),
  ctaBlock: () => client.getCtaBlock(),
  features: () => client.getFeaturesBlock(),
  trustpilot: () => client.getTrustpilotBlock(),
  news: () => client.getNewsBlock(),
  quickGuide: () => client.getQuickGuideBlock(),
  ctaFull: () => client.getCtaFull(),
  walletSecurity: () => client.getWalletSecurity(),
  walletFunctionalityList: () => client.getWalletFunctionalityList(),
  walletTrustpilot: () => client.getWalletTrustpilot(),
  walletFees: () => client.getWalletFees(),
  publicOnrampTrustpilot: () => client.getPublicOnrampTrustpilot(),
  affiliateProgram: () => client.getAffiliateProgram(),
  solutionInNumbers: () => client.getSolutionInNumbers(),
  cryptoTrends: () => client.getCryptoTrends(),
};

export default {
  getBlockHtml(blockName) {
    return blocks[blockName]()
      .then(({ html }) => html);
  },
};
